module.exports = __webpack_public_path__ + "static/media/group-161.6045e47d.svg";